import React from 'react'
import { CRow, CCol, CPlaceholder } from '@coreui/react-pro'

interface AccordionLoadingProps {
  height?: string
}

const AccordionLoading: React.FC<AccordionLoadingProps> = ({
  height = '200px',
}) => {
  return (
    <CRow>
      <CCol xs={12}>
        <CPlaceholder as="p" animation="glow">
          <CPlaceholder xs={12} style={{ height }} />
        </CPlaceholder>
      </CCol>
    </CRow>
  )
}

export default AccordionLoading
